import type { Comment } from '@kizen/api/comment';
import type { HTMLAttributes } from 'react';

import BubbleProfileImage from '__components/Charts/ScheduledActivities/BubbleProfileImage';
import { useDateTooltip } from '__components/Inputs/hooks/useDateTooltip';
import { formatTimestamp } from './helpers';
import { DateSpan, Message, MessageItem } from './styles';

type CommentBlockProps = {
  comment: Comment;
  isLast?: boolean;
};

interface DateTimeStampProps extends HTMLAttributes<HTMLSpanElement> {
  date: string;
}

export const DateTimeStamp = (props: DateTimeStampProps) => {
  const { date, ...rest } = props;

  const [dateTooltipProps, dateTooltip] = useDateTooltip({
    date,
  });

  return (
    <DateSpan {...dateTooltipProps} {...rest}>
      {dateTooltip}
      {formatTimestamp(date)}
    </DateSpan>
  );
};

export const CommentBlock = (props: CommentBlockProps) => {
  const { comment, isLast = false } = props;
  const { created_by: cb } = comment;

  const name = cb.last_name
    ? `${cb.first_name} ${cb.last_name}`
    : cb.first_name;

  return (
    <MessageItem isLast={isLast}>
      <BubbleProfileImage
        showToolTip
        imageURL={cb.picture_url}
        fullName={name}
      />
      <Message html={comment.text} />
      <DateTimeStamp date={comment.updated} />
    </MessageItem>
  );
};
